import { Modal } from 'react-bootstrap';
import ModelProfileEditor from './ModelProfileEditor';

/**
 * El editor de perfil dentro de un modal, para el panel de administración.
 *
 * El formulario en sí vive en <ModelProfileEditor />: la modelo lo usa como
 * pantalla completa en su propio panel, donde un modal no pinta nada.
 */
export default function ModelProfileManager({ show, onHide, model, onSaved }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="profile-manager-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa-solid fa-id-badge me-2"></i>
          Perfil público · {model?.user?.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ModelProfileEditor model={model} onSaved={onSaved} active={show} />
      </Modal.Body>
    </Modal>
  );
}
